import React from 'react'
import PropTypes from 'prop-types'
import styled, {css} from 'styled-components'
import {DialogContent as RmwcDialogContent} from '@rmwc/dialog'
import '@rmwc/dialog/styles'

export const dialogContentStyles = ({selector = '&&&'}) => css`
  ${selector} {
    font-family: 'Open Sans', sans-serif;
    font-size: 14px;
    font-weight: 400;
    line-height: 19.1px;
    padding: 0 2rem 0;
  }
`

const StyledRmwcDialogContent = styled(RmwcDialogContent)`
  ${dialogContentStyles}
`

const DialogContent = ({children, ...otherProps}) => <StyledRmwcDialogContent {...otherProps}>{children}</StyledRmwcDialogContent>

DialogContent.propTypes = {
  children: PropTypes.any
}

export {DialogContent}
